import { render } from "./CompleteStageWarning.vue?vue&type=template&id=78802af5"
import script from "./CompleteStageWarning.vue?vue&type=script&lang=js"
export * from "./CompleteStageWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__